import * as Schema from "effect/Schema";

/**
 * HeadingWidget — a themed heading backed by Duro's `<Heading>`. `level` is the
 * semantic 1–6 (Duro derives the type-scale step from it).
 */
export const HeadingWidgetContent = Schema.Struct({
  contentType: Schema.Literal("heading"),
  text: Schema.String,
  level: Schema.optional(Schema.Literal(1, 2, 3, 4, 5, 6)),
  /** Duro `Heading align`; absent = start. */
  align: Schema.optional(Schema.Literal("start", "center", "end")),
});
export type HeadingWidgetContent = Schema.Schema.Type<
  typeof HeadingWidgetContent
>;
